// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"5dc0430b","80":"f67a33a4","571":"372cda29","646":"48961918"}[chunkId] + ".chunk.js";
};